import format from 'date-fns/format';

/**
 *
 * @example output
 * "1983-04-13"
 */
export const getFormattedDateInISO = (date: Date): string => {
  return format(date, 'yyyy-MM-dd');
};
